var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('div',{staticClass:"loading d-flex flex-column justify-center align-center"},[(_vm.loadingMessage.length > 0)?_c('h2',{staticClass:"white--text mb-6"},[_vm._v(_vm._s(_vm.loadingMessage))]):_vm._e(),_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }